(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoro-category-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeYoroScrollSection = (root) => {
      if (!root || root.dataset.yoroInitialized === 'true') return;

      const track = root.querySelector('[data-yoro-scroll-track]');
      const previous = root.querySelector('[data-yoro-scroll-previous]');
      const next = root.querySelector('[data-yoro-scroll-next]');

      if (!track) return;
      root.dataset.yoroInitialized = 'true';

      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 2;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

        track.classList.toggle('is-centered', !overflow);

        if (previous) {
          previous.hidden = !overflow;
          previous.disabled = track.scrollLeft <= 2;
        }

        if (next) {
          next.hidden = !overflow;
          next.disabled = track.scrollLeft >= maxScroll - 2;
        }
      };

      const scrollByPage = (direction) => {
        const amount = Math.max(240, track.clientWidth * 0.78);
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => scrollByPage(-1));
      next?.addEventListener('click', () => scrollByPage(1));
      track.addEventListener('scroll', update, { passive: true });

      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(track);

      update();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-yoro-scroll-section]').forEach(initializeYoroScrollSection);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoro-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.yoroReviewInitialized === 'true') return;

      const track = root.querySelector('[data-yoro-review-track]');
      const previous = root.querySelector('[data-yoro-review-previous]');
      const next = root.querySelector('[data-yoro-review-next]');

      if (!track) return;
      root.dataset.yoroReviewInitialized = 'true';

      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 2;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);

        if (previous) {
          previous.hidden = !overflow;
          previous.disabled = track.scrollLeft <= 2;
        }

        if (next) {
          next.hidden = !overflow;
          next.disabled = track.scrollLeft >= maximum - 2;
        }
      };

      const move = (direction) => {
        track.scrollBy({
          left: Math.max(260, track.clientWidth * 0.82) * direction,
          behavior: 'smooth'
        });
      };

      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });

      const observer = new ResizeObserver(update);
      observer.observe(track);
      update();
    };

    const initializeAll = (scope = document) => {
      scope
        .querySelectorAll('[data-yoro-review-section]')
        .forEach(initialize);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoro-interactive-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
    const initializeYoroScrollSection = (root) => {
      if (!root || root.dataset.yoroInitialized === 'true') return;

      const track = root.querySelector('[data-yoro-scroll-track]');
      const previous = root.querySelector('[data-yoro-scroll-previous]');
      const next = root.querySelector('[data-yoro-scroll-next]');

      if (!track) return;
      root.dataset.yoroInitialized = 'true';

      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 2;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

        if (previous) {
          previous.hidden = !overflow;
          previous.disabled = track.scrollLeft <= 2;
        }

        if (next) {
          next.hidden = !overflow;
          next.disabled = track.scrollLeft >= maxScroll - 2;
        }
      };

      const scrollByPage = (direction) => {
        const amount = Math.max(260, track.clientWidth * 0.82);
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => scrollByPage(-1));
      next?.addEventListener('click', () => scrollByPage(1));
      track.addEventListener('scroll', update, { passive: true });

      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(track);
      update();
    };

    const WISHLIST_KEY = 'yorozuya_wishlist_v2';
    const WISHLIST_COOKIE = 'yorozuya_wishlist_v2';

    const parseWishlist = (value) => {
      try {
        const parsed = JSON.parse(value || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    };

    const readWishlistCookie = () => {
      const cookie = document.cookie
        .split('; ')
        .find((entry) => entry.startsWith(`${WISHLIST_COOKIE}=`));

      if (!cookie) return [];

      try {
        return parseWishlist(decodeURIComponent(cookie.split('=').slice(1).join('=')));
      } catch (error) {
        return [];
      }
    };

    const readWishlist = () => {
      try {
        const stored = window.localStorage.getItem(WISHLIST_KEY);
        if (stored !== null) return parseWishlist(stored);
      } catch (error) {
        console.warn('Local wishlist storage is unavailable.', error);
      }

      return readWishlistCookie();
    };

    const writeWishlist = (items) => {
      const serialized = JSON.stringify(items);

      try {
        window.localStorage.setItem(WISHLIST_KEY, serialized);
      } catch (error) {
        console.warn('Could not save wishlist to local storage.', error);
      }

      try {
        document.cookie =
          `${WISHLIST_COOKIE}=${encodeURIComponent(serialized)}; ` +
          'path=/; max-age=31536000; SameSite=Lax';
      } catch (error) {
        console.warn('Could not save wishlist cookie.', error);
      }
    };

    const getOrCreateWishlistToast = () => {
      let toast = document.querySelector('[data-yoro-wishlist-toast]');

      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'yoro-wishlist-toast';
        toast.dataset.yoroWishlistToast = 'true';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }

      return toast;
    };

    let wishlistToastTimer = null;

    const showWishlistToast = (message) => {
      const toast = getOrCreateWishlistToast();
      toast.textContent = message;
      toast.classList.add('is-visible');

      window.clearTimeout(wishlistToastTimer);
      wishlistToastTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 1700);
    };

    const updateHeaderWishlistCount = (count) => {
      const candidates = document.querySelectorAll(
        'a[href*="wishlist"], a[href*="favorites"], [data-wishlist-link], .header__icon--wishlist'
      );

      candidates.forEach((link) => {
        let badge = link.querySelector('[data-yoro-wishlist-count]');

        if (!badge && count > 0) {
          badge = document.createElement('span');
          badge.className = 'yoro-header-wishlist-count';
          badge.dataset.yoroWishlistCount = 'true';
          link.appendChild(badge);
        }

        if (badge) {
          badge.textContent = String(count);
          badge.hidden = count <= 0;
        }
      });
    };

    const setWishlistButtonState = (button, active) => {
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const label = active
        ? button.dataset.removeLabel
        : button.dataset.addLabel;

      if (label) {
        button.title = label;
        button.setAttribute(
          'aria-label',
          `${label}: ${button.dataset.productTitle || ''}`.trim()
        );
      }
    };

    const refreshWishlistButtons = (scope = document) => {
      const wishlist = readWishlist();
      const ids = new Set(wishlist.map((item) => String(item.id)));

      scope.querySelectorAll('[data-yoro-wishlist]').forEach((button) => {
        setWishlistButtonState(
          button,
          ids.has(String(button.dataset.productId))
        );
      });

      updateHeaderWishlistCount(wishlist.length);
    };

    const toggleWishlist = (button) => {
      const productId = String(button.dataset.productId || '');
      if (!productId) return;

      const wishlist = readWishlist();
      const existingIndex = wishlist.findIndex(
        (item) => String(item.id) === productId
      );

      let active;

      if (existingIndex >= 0) {
        wishlist.splice(existingIndex, 1);
        active = false;
      } else {
        wishlist.push({
          id: productId,
          handle: button.dataset.productHandle || '',
          url: button.dataset.productUrl || '',
          title: button.dataset.productTitle || '',
          image: button.dataset.productImage || '',
          price: button.dataset.productPrice || ''
        });
        active = true;
      }

      writeWishlist(wishlist);
      refreshWishlistButtons(document);

      const productTitle = button.dataset.productTitle || 'Product';
      showWishlistToast(
        active
          ? `${productTitle} added to favorites`
          : `${productTitle} removed from favorites`
      );

      document.dispatchEvent(
        new CustomEvent('yoro:wishlist-change', {
          detail: {
            count: wishlist.length,
            items: wishlist,
            active,
            productId
          }
        })
      );
    };

    const initializeWishlist = (root) => {
      if (!root) return;
      refreshWishlistButtons(root);
    };

    if (!window.__yoroWishlistClickBound) {
      window.__yoroWishlistClickBound = true;

      document.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('[data-yoro-wishlist]');
          if (!button) return;

          event.preventDefault();
          event.stopPropagation();
          toggleWishlist(button);
        },
        true
      );
    }

    window.YorozuyaWishlist = {
      getItems: readWishlist,
      refresh: () => refreshWishlistButtons(document),
      clear: () => {
        writeWishlist([]);
        refreshWishlistButtons(document);
      }
    };

    const refreshVisibleCartCount = async () => {
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootPath}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });

        if (!response.ok) return;

        const cart = await response.json();
        const count = Number(cart.item_count || 0);

        const existingBubbles = document.querySelectorAll('.cart-count-bubble');

        existingBubbles.forEach((bubble) => {
          const visibleCount =
            bubble.querySelector('span[aria-hidden="true"]') ||
            bubble.querySelector('span');

          if (visibleCount) {
            visibleCount.textContent = String(count);
          }

          const accessibleCount =
            bubble.querySelector('.visually-hidden') ||
            bubble.querySelector('[data-cart-count-text]');

          if (accessibleCount) {
            accessibleCount.textContent =
              count === 1 ? '1 item' : `${count} items`;
          }

          bubble.hidden = count <= 0;
          bubble.style.display = count > 0 ? '' : 'none';
        });

        if (count > 0 && existingBubbles.length === 0) {
          const cartLinks = Array.from(
            document.querySelectorAll(
              '#cart-icon-bubble, .header__icon--cart, a[href="/cart"], a[href$="/cart"]'
            )
          );

          const cartLink = cartLinks.find((element) => {
            return !element.closest('[data-yoro-product-form]');
          });

          if (cartLink) {
            const bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.setAttribute('data-yoro-cart-count-bubble', 'true');
            bubble.innerHTML = `
              <span aria-hidden="true">${count}</span>
              <span class="visually-hidden">${count === 1 ? '1 item' : `${count} items`}</span>
            `;
            cartLink.appendChild(bubble);
          }
        }

        document
          .querySelectorAll(
            '[data-cart-count], [data-cart-count-number], .cart-count'
          )
          .forEach((element) => {
            element.textContent = String(count);
            element.hidden = count <= 0;
          });

        document.dispatchEvent(
          new CustomEvent('yoro:cart-count-updated', {
            detail: { count, cart }
          })
        );
      } catch (error) {
        console.warn('Could not refresh cart count.', error);
      }
    };

    const initializeQuickAdd = (root) => {
      if (!root || root.dataset.yoroQuickAddInitialized === 'true') return;
      root.dataset.yoroQuickAddInitialized = 'true';

      root.addEventListener('submit', async (event) => {
        const form = event.target.closest('[data-yoro-product-form]');
        if (!form || !root.contains(form)) return;

        event.preventDefault();

        const button = form.querySelector('[data-yoro-cart-button]');
        if (!button || button.disabled) return;

        const originalMarkup = button.innerHTML;
        const endpoint = `${form.action.replace(/\.js$/, '')}.js`;

        button.disabled = true;

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });

          if (!response.ok) {
            throw new Error(`Cart add failed with status ${response.status}`);
          }

          button.classList.add('is-added');
          button.innerHTML = `
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="m9.1 16.2-4.3-4.3 1.4-1.4 2.9 2.9 8.7-8.7 1.4 1.4-10.1 10.1Z"/>
            </svg>
          `;

          await refreshVisibleCartCount();

          document.dispatchEvent(
            new CustomEvent('yoro:cart-added', {
              detail: { section: root }
            })
          );

          window.setTimeout(() => {
            button.classList.remove('is-added');
            button.innerHTML = originalMarkup;
            button.disabled = false;
          }, 1400);
        } catch (error) {
          console.error(error);
          button.disabled = false;
        }
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-yoro-scroll-section]').forEach((root) => {
        initializeYoroScrollSection(root);
        initializeWishlist(root);
        initializeQuickAdd(root);
      });
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    window.addEventListener('storage', () => {
      refreshWishlistButtons(document);
    });
  })();

  (() => {
    const initializeRailScroll = (root) => {
      const track = root.querySelector('[data-yoro-interactive-rail]');
      const previous = root.querySelector('[data-yoro-interactive-rail-previous]');
      const next = root.querySelector('[data-yoro-interactive-rail-next]');
      if (!track) return;

      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 2;
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);

        track.classList.toggle('is-centered', !overflow);

        if (previous) {
          previous.hidden = !overflow;
          previous.disabled = track.scrollLeft <= 2;
        }

        if (next) {
          next.hidden = !overflow;
          next.disabled = track.scrollLeft >= maximum - 2;
        }
      };

      previous?.addEventListener('click', () => {
        track.scrollBy({
          left: -Math.max(240, track.clientWidth * 0.78),
          behavior: 'smooth'
        });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({
          left: Math.max(240, track.clientWidth * 0.78),
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', update, { passive: true });

      const observer = new ResizeObserver(update);
      observer.observe(track);
      update();
    };

    const initializeInteractiveShowcase = (root) => {
      if (!root || root.dataset.yoroInteractiveInitialized === 'true') return;
      root.dataset.yoroInteractiveInitialized = 'true';

      initializeRailScroll(root);

      const tabs = Array.from(root.querySelectorAll('[data-yoro-interactive-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-yoro-interactive-panel]'));

      const activate = (tab, focusTab = false) => {
        if (!tab) return;
        const panelId = tab.dataset.panelId;

        tabs.forEach((candidate) => {
          const active = candidate === tab;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-selected', active ? 'true' : 'false');
          candidate.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });

        const activePanel = root.querySelector(`#${CSS.escape(panelId)}`);
        if (activePanel) {
          requestAnimationFrame(() => {
            activePanel
              .querySelectorAll('[data-yoro-scroll-track]')
              .forEach((track) => track.dispatchEvent(new Event('scroll')));
          });
        }

        if (focusTab) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));

        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          activate(tabs[nextIndex], true);
          tabs[nextIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        });
      });

      if (tabs[0]) activate(tabs[0]);

      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail?.blockId;
        if (!blockId) return;

        const tab = root.querySelector(
          `[data-yoro-interactive-tab][data-block-id="${CSS.escape(blockId)}"]`
        );

        if (tab) activate(tab);
      });
    };

    const initializeAllInteractiveShowcases = (scope = document) => {
      scope
        .querySelectorAll('[data-yoro-interactive-showcase]')
        .forEach(initializeInteractiveShowcase);
    };

    initializeAllInteractiveShowcases();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllInteractiveShowcases(event.target);
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yoro-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeYoroScrollSection = (root) => {
      if (!root || root.dataset.yoroInitialized === 'true') return;

      const track = root.querySelector('[data-yoro-scroll-track]');
      const previous = root.querySelector('[data-yoro-scroll-previous]');
      const next = root.querySelector('[data-yoro-scroll-next]');

      if (!track) return;
      root.dataset.yoroInitialized = 'true';

      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 2;
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

        if (previous) {
          previous.hidden = !overflow;
          previous.disabled = track.scrollLeft <= 2;
        }

        if (next) {
          next.hidden = !overflow;
          next.disabled = track.scrollLeft >= maxScroll - 2;
        }
      };

      const scrollByPage = (direction) => {
        const amount = Math.max(260, track.clientWidth * 0.82);
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => scrollByPage(-1));
      next?.addEventListener('click', () => scrollByPage(1));
      track.addEventListener('scroll', update, { passive: true });

      const resizeObserver = new ResizeObserver(update);
      resizeObserver.observe(track);
      update();
    };

    const WISHLIST_KEY = 'yorozuya_wishlist_v2';
    const WISHLIST_COOKIE = 'yorozuya_wishlist_v2';

    const parseWishlist = (value) => {
      try {
        const parsed = JSON.parse(value || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    };

    const readWishlistCookie = () => {
      const cookie = document.cookie
        .split('; ')
        .find((entry) => entry.startsWith(`${WISHLIST_COOKIE}=`));

      if (!cookie) return [];

      try {
        return parseWishlist(decodeURIComponent(cookie.split('=').slice(1).join('=')));
      } catch (error) {
        return [];
      }
    };

    const readWishlist = () => {
      try {
        const stored = window.localStorage.getItem(WISHLIST_KEY);
        if (stored !== null) return parseWishlist(stored);
      } catch (error) {
        console.warn('Local wishlist storage is unavailable.', error);
      }

      return readWishlistCookie();
    };

    const writeWishlist = (items) => {
      const serialized = JSON.stringify(items);

      try {
        window.localStorage.setItem(WISHLIST_KEY, serialized);
      } catch (error) {
        console.warn('Could not save wishlist to local storage.', error);
      }

      try {
        document.cookie =
          `${WISHLIST_COOKIE}=${encodeURIComponent(serialized)}; ` +
          'path=/; max-age=31536000; SameSite=Lax';
      } catch (error) {
        console.warn('Could not save wishlist cookie.', error);
      }
    };

    const getOrCreateWishlistToast = () => {
      let toast = document.querySelector('[data-yoro-wishlist-toast]');

      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'yoro-wishlist-toast';
        toast.dataset.yoroWishlistToast = 'true';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }

      return toast;
    };

    let wishlistToastTimer = null;

    const showWishlistToast = (message) => {
      const toast = getOrCreateWishlistToast();
      toast.textContent = message;
      toast.classList.add('is-visible');

      window.clearTimeout(wishlistToastTimer);
      wishlistToastTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 1700);
    };

    const updateHeaderWishlistCount = (count) => {
      const candidates = document.querySelectorAll(
        'a[href*="wishlist"], a[href*="favorites"], [data-wishlist-link], .header__icon--wishlist'
      );

      candidates.forEach((link) => {
        let badge = link.querySelector('[data-yoro-wishlist-count]');

        if (!badge && count > 0) {
          badge = document.createElement('span');
          badge.className = 'yoro-header-wishlist-count';
          badge.dataset.yoroWishlistCount = 'true';
          link.appendChild(badge);
        }

        if (badge) {
          badge.textContent = String(count);
          badge.hidden = count <= 0;
        }
      });
    };

    const setWishlistButtonState = (button, active) => {
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const label = active
        ? button.dataset.removeLabel
        : button.dataset.addLabel;

      if (label) {
        button.title = label;
        button.setAttribute(
          'aria-label',
          `${label}: ${button.dataset.productTitle || ''}`.trim()
        );
      }
    };

    const refreshWishlistButtons = (scope = document) => {
      const wishlist = readWishlist();
      const ids = new Set(wishlist.map((item) => String(item.id)));

      scope.querySelectorAll('[data-yoro-wishlist]').forEach((button) => {
        setWishlistButtonState(
          button,
          ids.has(String(button.dataset.productId))
        );
      });

      updateHeaderWishlistCount(wishlist.length);
    };

    const toggleWishlist = (button) => {
      const productId = String(button.dataset.productId || '');
      if (!productId) return;

      const wishlist = readWishlist();
      const existingIndex = wishlist.findIndex(
        (item) => String(item.id) === productId
      );

      let active;

      if (existingIndex >= 0) {
        wishlist.splice(existingIndex, 1);
        active = false;
      } else {
        wishlist.push({
          id: productId,
          handle: button.dataset.productHandle || '',
          url: button.dataset.productUrl || '',
          title: button.dataset.productTitle || '',
          image: button.dataset.productImage || '',
          price: button.dataset.productPrice || ''
        });
        active = true;
      }

      writeWishlist(wishlist);
      refreshWishlistButtons(document);

      const productTitle = button.dataset.productTitle || 'Product';
      showWishlistToast(
        active
          ? `${productTitle} added to favorites`
          : `${productTitle} removed from favorites`
      );

      document.dispatchEvent(
        new CustomEvent('yoro:wishlist-change', {
          detail: {
            count: wishlist.length,
            items: wishlist,
            active,
            productId
          }
        })
      );
    };

    const initializeWishlist = (root) => {
      if (!root) return;
      refreshWishlistButtons(root);
    };

    if (!window.__yoroWishlistClickBound) {
      window.__yoroWishlistClickBound = true;

      document.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('[data-yoro-wishlist]');
          if (!button) return;

          event.preventDefault();
          event.stopPropagation();
          toggleWishlist(button);
        },
        true
      );
    }

    window.YorozuyaWishlist = {
      getItems: readWishlist,
      refresh: () => refreshWishlistButtons(document),
      clear: () => {
        writeWishlist([]);
        refreshWishlistButtons(document);
      }
    };

    const refreshVisibleCartCount = async () => {
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootPath}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });

        if (!response.ok) return;

        const cart = await response.json();
        const count = Number(cart.item_count || 0);

        const existingBubbles = document.querySelectorAll('.cart-count-bubble');

        existingBubbles.forEach((bubble) => {
          const visibleCount =
            bubble.querySelector('span[aria-hidden="true"]') ||
            bubble.querySelector('span');

          if (visibleCount) {
            visibleCount.textContent = String(count);
          }

          const accessibleCount =
            bubble.querySelector('.visually-hidden') ||
            bubble.querySelector('[data-cart-count-text]');

          if (accessibleCount) {
            accessibleCount.textContent =
              count === 1 ? '1 item' : `${count} items`;
          }

          bubble.hidden = count <= 0;
          bubble.style.display = count > 0 ? '' : 'none';
        });

        if (count > 0 && existingBubbles.length === 0) {
          const cartLinks = Array.from(
            document.querySelectorAll(
              '#cart-icon-bubble, .header__icon--cart, a[href="/cart"], a[href$="/cart"]'
            )
          );

          const cartLink = cartLinks.find((element) => {
            return !element.closest('[data-yoro-product-form]');
          });

          if (cartLink) {
            const bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.setAttribute('data-yoro-cart-count-bubble', 'true');
            bubble.innerHTML = `
              <span aria-hidden="true">${count}</span>
              <span class="visually-hidden">${count === 1 ? '1 item' : `${count} items`}</span>
            `;
            cartLink.appendChild(bubble);
          }
        }

        document
          .querySelectorAll(
            '[data-cart-count], [data-cart-count-number], .cart-count'
          )
          .forEach((element) => {
            element.textContent = String(count);
            element.hidden = count <= 0;
          });

        document.dispatchEvent(
          new CustomEvent('yoro:cart-count-updated', {
            detail: { count, cart }
          })
        );
      } catch (error) {
        console.warn('Could not refresh cart count.', error);
      }
    };

    const initializeQuickAdd = (root) => {
      if (!root || root.dataset.yoroQuickAddInitialized === 'true') return;
      root.dataset.yoroQuickAddInitialized = 'true';

      root.addEventListener('submit', async (event) => {
        const form = event.target.closest('[data-yoro-product-form]');
        if (!form || !root.contains(form)) return;

        event.preventDefault();

        const button = form.querySelector('[data-yoro-cart-button]');
        if (!button || button.disabled) return;

        const originalMarkup = button.innerHTML;
        const endpoint = `${form.action.replace(/\.js$/, '')}.js`;

        button.disabled = true;

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });

          if (!response.ok) {
            throw new Error(`Cart add failed with status ${response.status}`);
          }

          button.classList.add('is-added');
          button.innerHTML = `
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="m9.1 16.2-4.3-4.3 1.4-1.4 2.9 2.9 8.7-8.7 1.4 1.4-10.1 10.1Z"/>
            </svg>
          `;

          await refreshVisibleCartCount();

          document.dispatchEvent(
            new CustomEvent('yoro:cart-added', {
              detail: { section: root }
            })
          );

          window.setTimeout(() => {
            button.classList.remove('is-added');
            button.innerHTML = originalMarkup;
            button.disabled = false;
          }, 1400);
        } catch (error) {
          console.error(error);
          button.disabled = false;
        }
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-yoro-scroll-section]').forEach((root) => {
        initializeYoroScrollSection(root);
        initializeWishlist(root);
        initializeQuickAdd(root);
      });
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    window.addEventListener('storage', () => {
      refreshWishlistButtons(document);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
